import React from 'react';
import {
  Mail,
  MapPin,
  Phone,
} from 'lucide-react';
import { FaInstagram, FaLinkedin, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './Footer.css';

const data = {
  facebookLink: '#', // No data provided
  instaLink: 'https://www.instagram.com/sparklingtech.es/',
  linkedinLink: 'https://www.linkedin.com/company/sparklingtechsolutions/',
  whatsappLink: 'https://wa.me/34680339168',
  youtubeLink: 'https://www.youtube.com/@SparklingTechSolutions',
  company: {
    name: 'Sparkling Tech Solutions',
    description:
      'Ciencia y videojuegos para ganar en salud. Tecnología inmersiva, neurociencia aplicada e inteligencia artificial para transformar el bienestar.',
    logo: '/img/logotipo-02.png',
  },
  contact: {
    email: 'info@sparklingtech.es',
    phone: '+34 680 339 168',
    address: 'España', // General location
  },
};

const socialLinks = [
  { icon: FaInstagram, label: 'Instagram', href: data.instaLink },
  { icon: FaLinkedin, label: 'LinkedIn', href: data.linkedinLink },
  { icon: FaWhatsapp, label: 'WhatsApp', href: data.whatsappLink },
  { icon: FaYoutube, label: 'YouTube', href: data.youtubeLink },
];

const aboutLinks = [
  { text: 'Conócenos', href: '/about' },
  { text: 'Proyectos', href: '/projects' },
  { text: 'Más allá del I + D + i', href: '/mas-alla-del-id' },
  { text: 'Nuestras Redes', href: '/nuestras-redes' },
];

const legalLinks = [
  { text: 'Política de privacidad', href: '/politica-privacidad' },
  { text: 'Uso de cookies', href: '/uso-cookies' },
  { text: 'Condiciones de uso', href: '/condiciones-de-uso' },
  { text: 'Aviso Legal', href: '/avisos-legales' },
  { text: 'Transparencia', href: '/portal-transparencia' },
  { text: 'Mapa del sitio', href: '/mapa-sitio' },
];

const contactInfo = [
  { icon: Mail, text: data.contact.email, href: `mailto:${data.contact.email}` },
  { icon: Phone, text: data.contact.phone, href: `tel:${data.contact.phone.replace(/\s/g, '')}` },
  { icon: MapPin, text: data.contact.address, isAddress: true },
];

export default function Footer() {
  return (
    <footer className="footer-new">
      <div className="footer-container-new">
        <div className="footer-grid">
          {/* Columna 1: Logo y Partners */}
          <div className="footer-brand">
            <div className="brand-header">
              <Link to="/">
                <img
                  src={data.company.logo || '/placeholder.svg'}
                  alt="Sparkling Tech Logo"
                  className="brand-logo-large"
                />
              </Link>
            </div>
            
            {/* Logos de Partners RESTAURADOS */}
            <div className="partners-grid">
               <a href="https://www.enisa.es/" target="_blank" rel="noopener noreferrer">
                <img src="/img/enisablanco.png" alt="Enisa" className="partner-logo" />
              </a>
              <a href="https://www.ulpgc.es/noticia/2025/05/12/sparkling-tech-solutions-nueva-startup-ulpgc-especializada-neurociencia-aplicada" target="_blank" rel="noopener noreferrer">
                <img src="/img/selloULPGC2.png" alt="Sello ULPGC" className="partner-logo white-filter" />
              </a>
              <a href="https://www.top101spainupnation.com/empresas-top101-2025/" target="_blank" rel="noopener noreferrer">
                  <img src="/img/Sello-SUN-Top-101-Color-Horizontal_empresa-101.png" alt="Top 101" className="partner-logo wide white-filter"/>
              </a>
              <a href="https://www.ipfest.es/" target="_blank" rel="noopener noreferrer">
                <img src="/img/IPFest3.png" alt="IPFest" className="partner-logo white-filter" />
              </a>
            </div>
          </div>

          {/* Columnas de Enlaces */}
          <div className="footer-links-grid">
            {/* Columna 2: Sobre Nosotros */}
            <div className="footer-column">
              <p className="column-title">Sobre Nosotros</p>
              <ul className="column-list">
                {aboutLinks.map(({ text, href }) => (
                  <li key={text}>
                    <Link className="footer-link" to={href}>
                      {text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Columna 3: Enlaces Legales */}
            <div className="footer-column">
              <p className="column-title">Legal</p>
              <ul className="column-list">
                {legalLinks.map(({ text, href }) => (
                  <li key={text}>
                    <Link className="footer-link" to={href}>
                      {text}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Columna 4: Contacto */}
            <div className="footer-column">
              <p className="column-title">Contáctanos</p>
              <ul className="column-list">
                {contactInfo.map(({ icon: Icon, text, href, isAddress }) => (
                  <li key={text}>
                    {href ? (
                      <a className="contact-link" href={href}>
                        <Icon className="contact-icon-small" size={20} />
                        <span className="contact-text transition">
                          {text}
                        </span>
                      </a>
                    ) : (
                      <div className="contact-link">
                        <Icon className="contact-icon-small" size={20} />
                         <address className="contact-text not-italic transition">
                          {text}
                        </address>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
              {/* Iconos de Redes Sociales MOVIDOS AQUÍ */}
              <div className="social-links-contact">
                {socialLinks.map(({ icon: Icon, label, href }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link-item-contact"
                  >
                    <span className="sr-only">{label}</span>
                    <Icon size={20} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p className="copyright-text">
              <span className="desktop-inline">Todos los derechos reservados.</span>
            </p>

            <p className="copyright-text mt-4 sm:mt-0">
              &copy; {new Date().getFullYear()} {data.company.name}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
